// import { createSelector } from 'reselect'
// import { getActiveServerId } from '../activeServer/selectors'

// TODO: FIX THIS!!!!
//       To fix this we need to get a fix from the backend
//       Need to talk to RnB about this

// eslint-disable-next-line
export const getPlayableServers = state => state.backendReducer.playable || {}
export const getPlayable = () => true
// export const getPlayable = (state, serverId) => {
//     const playableServers = getPlayableServers(state)
//     return playableServers[serverId] || false
// }
export const getActivePlayable = () => true
// export const getActivePlayable = createSelector(
//     [getActiveServerId, getPlayableServers],
//     (active, playableServers) => playableServers[active] || false,
// )



// WEBPACK FOOTER //
// ./src/features/Backend/data/playable/selectors.js